import { ATLAS_REGION_LABEL, CONSENT_SHEET, DEFAULT_CONSENT_VARS, renderConsent, type ConsentVars } from '@aera/content/client';
import type { ClientConfig, Lang } from '@aera/schema';

/** The placeholders from the API's config; the region named is the configured ATLAS_REGION (decision 3). */
export const consentVars = (
  config: (Pick<ClientConfig, 'privacyEmail' | 'retentionMonths'> & Partial<Pick<ClientConfig, 'atlasRegion'>>) | null,
): ConsentVars => ({
  ...DEFAULT_CONSENT_VARS,
  ...(config ? { privacyEmail: config.privacyEmail, retentionMonths: config.retentionMonths } : {}),
  ...(config?.atlasRegion && ATLAS_REGION_LABEL[config.atlasRegion] ? { atlasRegion: ATLAS_REGION_LABEL[config.atlasRegion] } : {}),
});

/** Page 1 of the consent sheet: what is stored, who sees it, for how long, and the respondent's rights. */
export function ProcessingText({ lang, vars }: { lang: Lang; vars: ConsentVars }) {
  const sheet = CONSENT_SHEET.processing;
  return (
    <div className="space-y-4 text-[15.5px] leading-[1.75]">
      <p>{renderConsent(sheet.intro, lang, vars)}</p>
      <dl className="space-y-3">
        {sheet.sections.map((s) => (
          <div key={s.label.en}>
            <dt className="font-semibold">{s.label[lang]}</dt>
            <dd className="text-ink-2">{renderConsent(s.body, lang, vars)}</dd>
          </div>
        ))}
      </dl>
    </div>
  );
}

/** Page 2: storage abroad and the model call; the local-model wording when the model runs on Aera's server. */
export function CrossBorderText({ lang, vars, llmMode }: { lang: Lang; vars: ConsentVars; llmMode: 'cloud' | 'local' }) {
  const sheet = CONSENT_SHEET.crossBorder;
  return <p className="text-[15.5px] leading-[1.75] text-ink-2">{renderConsent(llmMode === 'local' ? sheet.bodyLocalModel : sheet.body, lang, vars)}</p>;
}

export const versionLine = (lang: Lang, version: string, vars: ConsentVars) => renderConsent(CONSENT_SHEET.versionLine, lang, { ...vars, version });
